// extracted by mini-css-extract-plugin
export var circle = "_2j-2";
export var icon = "_2j-a";
export var iconHighlight = "_2j-0";
export var lg = "_2j-8";
export var md = "_2j-7";
export var outline = "_2j-4";
export var sm = "_2j-6";
export var square = "_2j-1";
export var xl = "_2j-9";
export var xs = "_2j-5";
export var xxs = "_2j-3";